import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type WebPagePathDataFragment = (
  { __typename: 'WebPagePath' }
  & Pick<SchemaTypes.WebPagePath, 'webpageId' | 'webpageSubpath'>
);

export const WebPagePathDataFragmentDoc = /*#__PURE__*/ gql`
    fragment WebPagePathData on WebPagePath {
  webpageId
  webpageSubpath
}
    `;